// Shared disclosure PDF builder used by DisclosuresStage (send) and
// MessageThread (view from disclosure message card).

export const SECTION_NAMES = {
  TDS:  "Transfer Disclosure Statement",
  SPQ:  "Seller Property Questionnaire",
  NHD:  "Natural Hazard Disclosure",
  LEAD: "Lead-Based Paint Disclosure",
  HOA:  "HOA Disclosure",
};

export function buildPrintHTML(address, questions, answers, summary) {
  const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const sections = [...new Set(questions.map((q) => q.section))];
  const formsLine = sections.length ? sections.join(" · ") : "Standard seller disclosures";

  const qHTML = sections.map((sec) => {
    const qs = questions.filter((q) => q.section === sec);
    return `<div class="sec">
      <div class="sec-title">${SECTION_NAMES[sec] || sec}</div>
      ${qs.map((q) => {
        const a = answers[q.id] || {};
        const isYes = a.answer === "yes";
        return `<div class="q-row">
          <div class="q-text">${q.q}</div>
          <div class="q-ans ${isYes ? "yes" : "no"}">${(a.answer || "—").toUpperCase()}</div>
          ${a.note ? `<div class="q-note">${a.note}</div>` : ""}
        </div>`;
      }).join("")}
    </div>`;
  }).join("");

  const summaryHTML = summary
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/^## (.+)$/gm, "<h3>$1</h3>")
    .replace(/^- (.+)$/gm, "<li>$1</li>")
    .replace(/(<li>.*<\/li>\n?)+/g, (m) => `<ul>${m}</ul>`)
    .replace(/\n/g, "<br>");

  return `<!DOCTYPE html><html><head><meta charset="UTF-8">
<title>Disclosure Docket — ${address}</title><style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:Georgia,serif;max-width:820px;margin:40px auto;color:#1a1a1a;line-height:1.65;padding:0 24px}
  h1{font-size:22px;font-weight:700;border-bottom:2px solid #1a1a1a;padding-bottom:12px;margin-bottom:8px}
  .meta{font-size:12px;color:#555;margin-bottom:32px;font-family:monospace;letter-spacing:0.04em}
  .sec{margin-bottom:28px}
  .sec-title{font-size:11px;font-family:monospace;letter-spacing:0.12em;text-transform:uppercase;color:#2d7a62;background:#f2f8f5;padding:6px 10px;border-radius:4px;margin-bottom:12px;font-weight:700}
  .q-row{padding:10px 0;border-bottom:1px solid #f0f0f0}
  .q-row:last-child{border-bottom:none}
  .q-text{font-size:13px;margin-bottom:4px}
  .q-ans{font-family:monospace;font-size:11px;font-weight:700;letter-spacing:0.08em}
  .q-ans.yes{color:#c0354a}.q-ans.no{color:#2d7a62}
  .q-note{font-size:12px;color:#555;margin-top:4px;font-style:italic;padding-left:12px;border-left:2px solid #d0d0d0}
  h2{font-size:16px;font-weight:700;margin:32px 0 12px}
  .summary{background:#f9f9f9;border-left:4px solid #2d7a62;padding:20px 24px;border-radius:0 8px 8px 0}
  .summary h3{font-size:14px;margin:16px 0 6px}
  .summary ul{padding-left:20px;margin:4px 0}
  .summary li{font-size:13px;margin-bottom:3px}
  .disclaimer{font-size:10px;color:#999;margin-top:40px;padding-top:16px;border-top:1px solid #e0e0e0;line-height:1.8}
  @media print{body{margin:20px}}
</style></head><body>
  <h1>Seller Disclosure Docket</h1>
  <div class="meta">Property: <strong>${address}</strong> &nbsp;·&nbsp; Generated: ${date} &nbsp;·&nbsp; Forms: ${formsLine}</div>
  <h2>Interview Questions &amp; Answers</h2>
  ${qHTML}
  <h2>Disclosure Summary</h2>
  <div class="summary">${summaryHTML}</div>
  <div class="disclaimer">
    This document was generated by 6zero.ai as an organizational aid for the seller's disclosure process.
    It does not constitute legal advice and does not replace the review of a licensed real estate attorney or agent.
    Sellers are responsible for ensuring all required disclosures are completed accurately and submitted
    to the appropriate parties in the format required by their property's state law.
  </div>
  <script>window.onload = () => window.print();<\/script>
</body></html>`;
}

export function openDisclosurePDF(address, questions, answers, summary) {
  const win = window.open("", "_blank");
  if (!win) { alert("Allow pop-ups to view the PDF."); return; }
  win.document.write(buildPrintHTML(address, questions, answers, summary));
  win.document.close();
}
